<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="page_10"></a><strong>NEEDED MONEY OF MY OWN, SO I STARTED SLANGIN’</strong></h3>
<p class="noindentb"><span class="small">LYRIC FROM SONG: <strong>“DEAR MAMA”</strong> ON ALBUM: <strong>ME AGAINST THE WORLD</strong> BY ARTIST</span>: 2PAC</p>
<p class="noindent">For some people, there comes a time during their youth when they realize they can no longer live the lifestyle they want based solely on the support of individuals such as their mother who may provide for them, so they begin selling drugs as a way to survive and secure their own financial well-being.</p>
<h4 class="h4"><a id="page_11"></a><strong>BAG FULL OF CHIPS—WE AIN’T TALKIN’ RUFFLES</strong></h4>
<p class="noindentb"><span class="small">LYRIC FROM SONG: <strong>“THROW IT IN THE BAG”</strong> ON ALBUM: <strong>LOSO’S WAY</strong> BY ARTIST</span>: <strong>FABOLOUS</strong></p>
<p class="noindent">I have a bag that contains a large amount of paper money that I am describing by using a term that stems from the circular disks casinos use as in-house currency, clarifying that it is not a particular brand of thin crinkle-cut potato slices that you may have thought I was referring to.</p>
<h4 class="h4"><strong>THAT PABLO ESCOBAR CRACK MONEY</strong></h4>
<p class="noindentb"><span class="small">LYRIC FROM SONG: <strong>“MONEY”</strong> ON ALBUM: <strong>LAX</strong> BY ARTIST</span>: <strong>THE GAME</strong></p>
<p class="noindent">I am striving to accumulate the same amount of wealth an infamous Colombian drug lord had at the height of his career—somewhere in the billions of dollars.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01ch07.vue?4a542804